import { ReactNode } from "react";
import SidebarModal from "./SidebarModal";

interface props {
  children: ReactNode;
}

const Layout = ({ children }: props) => {
  return (
    <div className="w-full sm:h-full md:h-screen flex justify-center items-center bg-slate-300">
      <div className="sm:w-full xl:w-[90%] 2xl:w-[70%] sm:h-full xl:h-[700px] 2xl:h-[750px] bg-white shadow-md sm:rounded-none md:rounded-lg overflow-hidden relative">
        <SidebarModal />
        {children}
      </div>
    </div>
  );
};

export default Layout;
